import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronRight } from "lucide-react";

// STYLES
import "../styles/Top100Preview.css";
import "../App.css";

// SERVICES
import { Top100Service } from "../services/Top100Service";

// TYPES
import { TrackData } from "../types/Types";

// COMPONENTS
import { AudioTrack } from "./AudioTrack";

export const Top100Preview = () => {
  const [tracks, setTracks] = useState<TrackData[]>([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const loadPreview = async () => {
      const data = await Top100Service.fetchTop100Tracks();

      const top10 = data.slice(0, 10);

      setTracks(top10);
      setLoading(false);
    };

    loadPreview();
  }, []);

  if (loading) return <div className="loading-preview">Loading Chart...</div>;

  return (
    <section className="feed-section">
      <div className="section-header header-gradient">
        <div className="header-title-group">
          <div className="top100-preview-header">
            <h2 className="augio-brand-text">AUGIO</h2>
            <div className='top100-preview-header-text'>TOP 100</div>
          </div>
           
        </div>

        <button
          className="top-100-view-chart-btn"
          onClick={() => navigate("/top100")}
        >
          View Full Chart <ChevronRight size={16} />
        </button>
      </div>

      <div className="track-list">
        {tracks.map((track, index) => (
          <AudioTrack key={track.id} track={track} rank={index + 1} />
        ))}
      </div>
    </section>
  );
};